<template>
  <aside class="sidebar">
    <div v-if="!isMobile" class="sidebar__items-wrapper">
      <a
        v-for="(item, n) in sidebarList"
        :key="item.slug"
        class="sidebar__item"
        :class="{ 'sidebar__item--active': activatedTabIdx === n }"
        :href="item.slug"
        @click.prevent="activateTabByIdx(n)"
        v-html="item.title"
      />
    </div>
    <div v-if="isMobile" class="sidebar__items-wrapper sidebar__items-wrapper-mob">
      <multiselect
        v-model="activeSelectItem"
        class="multiselect--sub-small sidebar__mobile"
        trackBy="slug"
        :options="sidebarList"
        label="title"
        :showLabels="false"
        openDirection="bottom"
        placeholder="Select an Option"
        :searchable="false"
        :allowEmpty="false"
        @select="activateTabBySlug"
      />
    </div>
  </aside>
</template>
<script>
import { useScreenWidth } from '@/composables/useScreenWidth'
export default {
  name: 'Sidebar',
  components: {},
  props: {
    sidebarList: {
      type: Array,
      default: () => {},
    },
    activatedTabIdx: {
      type: Number,
      default: 0,
    },
  },
  emits: ['selected'],
  setup() {
    const { isMobile } = useScreenWidth()

    return {
      isMobile,
    }
  },
  data() {
    return {
      activeSelectItem: null,
    }
  },
  watch: {
    activatedTabIdx: {
      handler(nv, ov) {
        if (nv !== undefined && nv !== null && nv !== ov) {
          this.activeSelectItem = this.sidebarList[this.activatedTabIdx]
        }
      },
      immediate: true,
    },
  },
  methods: {
    activateTabByIdx(tabIdx) {
      this.$emit('selected', tabIdx)
    },
    activateTabBySlug(item) {
      const tabIdx = this.sidebarList.findIndex((el) => el.slug === item.slug)
      this.$emit('selected', tabIdx)
    },
  },
}
</script>
